if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      getFocusReturnElement() {
        const activeMediaItem = this.querySelector('.product-media-item.active');
        if (!activeMediaItem) return this.openedBy;

        const mediaId = activeMediaItem.getAttribute('data-media-id');
        const mediaIndex = activeMediaItem.getAttribute('data-index');
        const section = this.dataset.section
          ? document.getElementById(`shopify-section-${this.dataset.section}`)
          : null;
        const scope = section || document;

        const mediaButton = scope.querySelector(`button.product__media-toggle[data-media-id="${mediaId}"]`);
        if (mediaButton) return mediaButton;

        const mediaList = scope.querySelector('ul.product__media-list');
        if (mediaList && mediaIndex !== null) {
          const mediaButtons = mediaList.querySelectorAll('button.product__media-toggle');
          const index = parseInt(mediaIndex, 10);
          if (!Number.isNaN(index) && mediaButtons[index]) return mediaButtons[index];
        }

        return this.openedBy;
      }

      hide() {
        const elementToFocus = this.getFocusReturnElement();
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        toggleModalBackgroundInert(this, false);
        removeTrapFocus(elementToFocus);
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
